import { Link } from 'react-router-dom';
import './astyles/TableSelector.css';

export default function TableSelector() {
  return (
    <div className="table-selector">
      <h2>Manage Data Tables</h2>
      <div className="selector-grid">
        <Link to="/admin/manage-records/volunteers" className="selector-card">
          <h3>Volunteers</h3>
          <p>View and manage volunteers</p>
        </Link>
        
        <Link to="/admin/manage-records/projects" className="selector-card">
          <h3>Projects</h3>
          <p>Manage projects and tasks</p>
        </Link>
        
        <Link to="/admin/manage-records/skills" className="selector-card">
          <h3>Skills</h3>
          <p>Manage skills and competencies</p>
        </Link>
        
        <Link to="/admin/manage-records/locations" className="selector-card">
          <h3>Locations</h3>
          <p>Manage project locations</p>
        </Link>
        
        <Link to="/admin/manage-records/donations" className="selector-card">
          <h3>Donations</h3>
          <p>View and manage donations</p>
        </Link>
      </div>
    </div>
  );
}